module.exports = __webpack_public_path__ + "static/media/telematics_yellow.0a6a3599.png";